export enum ComponentTypes {
	Requests,
	Accounts
}